// Module
var code = "<!-- ko if: !_isEditMode() --> <div class=\"grid-cell-wrapper\"> <span data-bind=\"html: $data.ViewValue\"></span> </div> <!-- /ko --> <!-- ko if: _isEditMode() --> <!-- ko with: _editor --> <!-- ko template: {name: $data.GetTemplateName.bind($data), afterRender: $data.AfterRender.bind($data)} --> <!-- /ko --> <!-- /ko --> <!-- /ko --> ";
// Exports
export default code;